import { render, staticRenderFns } from "./shopheader.vue?vue&type=template&id=420929a8&"
import script from "./shopheader.vue?vue&type=script&lang=js&"
export * from "./shopheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports